<template>
  <el-row class="pond-info-tab" slot="pondlogs-default-layout-main">
    <el-row type="flex" :gutter="20">
      <el-col :span="getGraphPanelStatus ? 14 : 24">
        <el-card class="pond-table-container">
          <el-row class="pre-table-header" type="flex">
            <el-col :span="10" class="pre-table-header__left">
              <el-radio-group
                :value="selectedTab"
                size="small"
                @input="handleTabClick($event, 'TAB_CLICK')"
              >
                <el-radio-button label="ACTIVE" class="is-plain">
                  {{ $t("Comn_active") }}
                </el-radio-button>
                <el-radio-button label="INACTIVE" class="is-plain">
                  {{ $t("Comn_inactive") }}
                </el-radio-button>
                <el-radio-button label="ALL" class="is-plain">
                  {{ $t("all") }}
                </el-radio-button>
              </el-radio-group>
            </el-col>
            <el-col
              :span="14"
              class="pre-table-header__right"
              v-bind:class="{ rightWidthAdj: !isDeactive }"
            >
              <layout-toolbar>
                <div
                  class="day-picker-top"
                  v-bind:class="{ hideDayPicker: !isDeactive }"
                >
                  <er-single-day-picker
                    size="mini"
                    :clearable="false"
                    :value="momentDate"
                    :picker-options="pickerOptions"
                    :disabled="true"
                    value-format="yyyy-MM-dd"
                    :format="$commonUtils.DATE_OBJ_DATE_FORMAT_WITH_YEAR"
                    @change="handleChangeInDateRange"
                  ></er-single-day-picker>
                </div>

                <img
                  class="clear-selection-icon"
                  @click="clearSelectionClick"
                  src="@/assets/barspondinfo.svg"
                />

                <er-list-filter
                  :data="getFilterData"
                  value-key="pond_id"
                  search-on-key="label"
                  :defaultCheckedKeys="getAvailablePondIds"
                  @check-change="handleChangeInSelectedPonds"
                >
                  <template v-slot:label="{ item }">{{ item.label }}</template>
                </er-list-filter>

                <er-column-selector
                  :key-to-store-defaults="`${getUserId}-TABLE-PREF-POND-INFO`"
                  :columns="tableColumns"
                  :keyToDecideDefaultCol="keyToDecideDefaultCol"
                  :srcImg="'COLUMN_ICON'"
                  :type="'columns'"
                  :title="'Column Visibility'"
                  @change-selection="handleChangeInColumnSelection"
                ></er-column-selector>

                <div class="search-bar" :title="$t('Comn_search')">
                  <el-input
                    class="search-bar-size"
                    v-show="!isDeactive"
                    v-model="pondSearch"
                    size="small"
                    :placeholder="$t('Pond_search_pond')"
                  ></el-input>

                  <i
                    class="el-icon-search search_icon column__selectors"
                    @click="searchClick"
                  />
                </div>

                <er-button
                  class="collapsebutton__selectors"
                  type="text"
                  v-if="getGraphPanelStatus"
                  :title="$t('expand')"
                  size="mini"
                  @click="handleExpandClick(false)"
                >
                  <i class="el-icon-arrow-left"></i>
                  <i class="el-icon-arrow-right"></i>
                </er-button>
                <er-button
                  class="collapsebutton__selectors"
                  type="text"
                  v-else
                  :title="$t('show_graphs')"
                  size="mini"
                  @click="handleExpandClick(true)"
                >
                  <i class="el-icon-arrow-right"></i>
                  <i class="el-icon-arrow-left"></i>
                </er-button>
              </layout-toolbar>
            </el-col>
          </el-row>
          <card-all-ponds-table
            :filteredPonds="tableData"
            :loading="loading"
            :selectedHeaders="selectedHeaders"
            :userCountryCode="getUserProfile.country.code"
          />
        </el-card>
      </el-col>
      <el-col
        :span="getGraphPanelStatus ? 10 : 0"
        style="padding-left: 0px; padding-right: 0px;"
      >
        <info-charts></info-charts>
      </el-col>
    </el-row>
  </el-row>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import errorHandlerMixin from "@/mixins/errorHandlerMixin.js";
import infoCharts from "./components/infoCharts";
import cardAllPondsTable from "./components/cardAllPondsTable";

export default {
  name: "PondInfoTab",
  mixins: [errorHandlerMixin],
  data: function() {
    return {
      date: null,
      visible: false,
      isDeactive: true,
      pondSearch: "",
      filteredponds: [],
      selectedPondsIds: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      selectedHeaders: {},
      selectedColumnsKeys: [],
      loading: true,
      params: {
        get_all: true,
        status: ["ACTIVE", "INACTIVE"]
      },
      query: {
        location_id: null,
        biomass_units: "KG",
        include: ["title", "pond_mothers", "shrimp_talks", "pond_guards"]
      }
    };
  },

  components: {
    cardAllPondsTable,
    infoCharts
  },
  computed: {
    ...mapGetters("user", {
      getCurrUserLocation: "getCurrUserLocation",
      getUserTimeZone: "getUserTimeZone",
      getUserCountryName: "getUserCountryName",
      getUserProfile: "getUserProfile"
    }),
    ...mapGetters("pondInfo", {
      getSelectedTab: "getSelectedTab",
      getActivePonds: "getActivePonds",
      getInactivePonds: "getInactivePonds",
      getAllPonds: "getAllPonds",
      getAllHyperLinkPonds: "getAllHyperLinkPonds",
      getPondIdToLatestNDOTempValues: "getPondIdToLatestNDOTempValues",
      getGraphPanelStatus: "getGraphPanelStatus"
    }),
    getUserId() {
      return this.getUserProfile._id;
    },
    pondsForSelection() {
      let ponds = [];
      if (this.selectedTab === "ACTIVE") {
        ponds = this.activePonds || [];
      } else if (this.selectedTab === "INACTIVE") {
        ponds = this.inactivePonds || [];
      } else if (this.selectedTab === "ALL") {
        ponds = this.getAllPonds || [];
      }
      return ponds;
    },
    getFilterData() {
      return this.pondsForSelection
        .map(x => {
          return { pond_id: x._id, label: x.title };
        })
        .sort((a, b) =>
          this.$commonUtils.alphaNumericComparator(a.label, b.label)
        );
    },
    getAvailablePondIds() {
      return this.pondsForSelection.map(x => x._id);
    },
    selectedTab() {
      console.log(this.getSelectedTab);
      return this.getSelectedTab;
    },
    activePonds: function() {
      return this.getActivePonds || [];
    },
    inactivePonds: function() {
      return this.getInactivePonds;
    },
    tableColumns() {
      return {
        title: {
          label: this.$t("Comn_name"),
          prop: "title",
          sortable: true,
          minWidth: 90,
          fixed: "left",
          align: "left",
          default: true,
          sortMethod: (a, b) =>
            this.$commonUtils.alphaNumericComparator(a.title, b.title),
          defaultFullTable: true
        },
        size: {
          label: this.$tc("Pond_size", 1),
          sub_label: this.pondSizeUnits.units,
          prop: "size",
          default: true,
          sortable: true,
          minWidth: 100,
          defaultFullTable: true,
          align: "left"
        },

        days_of_cultivation: {
          label: this.$t("Comn_doc"),
          sub_label: this.$t("Comn_days"),
          prop: "days_of_cultivation",
          sortable: true,
          default: true,
          defaultFullTable: true,
          minWidth: 90,
          align: "left"
        },
        abw: {
          label: this.$t("ABW_abw"),
          sub_label: "g",
          prop: "abw",
          sortable: true,
          align: "left",
          default: true,
          defaultFullTable: true
        },
        biomass: {
          label: this.$t("Comn_biomass"),
          sub_label: "kg",
          prop: "biomass",
          sortable: true,
          align: "left",
          default: true,
          minWidth: 110,
          defaultFullTable: true
        },
        total_feed: {
          label: this.$t("Comn_net_feed"),
          sub_label: "kg",
          prop: "total_feed",
          sortable: true,
          minWidth: 100,
          default: true,
          defaultFullTable: true,
          align: "left"
        },
        do: {
          label: this.$t("Comn_do"),
          sub_label: "mg/L",
          prop: "do",
          sortable: true,
          minWidth: 85,
          default: true,
          defaultFullTable: true,
          align: "left",
          sortMethod: (a, b) => this.sortDo(a, b)
        },
        temp: {
          label: this.$t("Comn_temp"),
          sub_label: "\u00b0C",
          prop: "temp",
          sortable: true,
          minWidth: 80,
          default: false,
          defaultFullTable: true,
          align: "left",
          sortMethod: (a, b) => this.sortTemperature(a, b)
        },
        post_larva_stocked: {
          label: this.$t("Pond_pls_stocked"),
          prop: "post_larva_stocked",
          sortable: true,
          minWidth: 108,
          defaultFullTable: true,
          default: false,
          align: "left"
        },
        survival_percentage: {
          label: this.$t("Comn_survival_percentage"),
          prop: "survival_percentage",
          sortable: true,
          minWidth: 115,
          defaultFullTable: true,
          align: "left",
          default: false
        },

        fcr: {
          label: this.$t("Comn_fcr"),
          prop: "fcr",
          sortable: true,
          minWidth: 80,
          defaultFullTable: true,
          default: false,
          align: "left"
        },
        mode: {
          label: this.$t("PM_mode"),
          prop: "mode",
          sortable: true,
          width: 100,
          defaultFullTable: true,
          default: false,
          align: "left"
        }
      };
    },
    pondSizeUnits: function() {
      return this.getUserCountryName.toLowerCase() === "india"
        ? { units: "ac", lang_key: "Pond_size_units_ac" }
        : { units: "ha", lang_key: "Pond_size_units_ha" };
    },
    momentDate: {
      get() {
        return this.date;
      },
      set(value) {
        this.date = value;
      }
    },
    tableData: function() {
      let ponds = [];
      if (this.selectedTab === "ACTIVE") {
        ponds = this.activePonds || [];
      } else if (this.selectedTab === "INACTIVE") {
        ponds = this.inactivePonds || [];
      } else if (this.selectedTab === "ALL") {
        ponds = this.getAllPonds || [];
      }
      const finalPondsObjById = ponds.reduce((acc, pond) => {
        acc[pond._id] = pond;
        return acc;
      }, {});
      let finalPondsArr = ponds;
      // dashboard
      if ((this.getAllHyperLinkPonds || []).length > 0) {
        const pondIds = this.getAllHyperLinkPonds.map(x => x._id);
        finalPondsArr = pondIds.map(id => finalPondsObjById[id]);
      } else if ((this.selectedPondsIds || []).length > 0) {
        // pond filter
        const pondIds = this.selectedPondsIds;
        finalPondsArr = pondIds.map(id => finalPondsObjById[id]);
      }
      // searching
      finalPondsArr = finalPondsArr.filter(
        pond =>
          !this.pondSearch ||
          (pond || { title: "No Data" }).title
            .toLowerCase()
            .includes(this.pondSearch.toLowerCase())
      );

      if (finalPondsArr.length > 0) {
        return finalPondsArr;
      } else {
        return ponds;
      }
    },
    keyToDecideDefaultCol: function() {
      return this.getGraphPanelStatus ? "default" : "defaultFullTable";
    }
  },
  async mounted() {
    this.$moment.locale(this.$i18n.locale);
    this.initDate();
    await this.initComponent();
  },
  methods: {
    ...mapActions("pondInfo", {
      changeSelectedTab: "changeSelectedTab",
      changeSelectedPonds: "changeSelectedPonds",
      changeLocation: "changeLocation",
      changeDashboardTabSelectedPondIds: "changeDashboardTabSelectedPondIds",
      changeShowGraphsPanelStatus: "changeShowGraphsPanelStatus"
    }),

    async handleTabClick(selectedLabel, eventTrigger) {
      this.loading = true;
      if (eventTrigger === "TAB_CLICK") {
        await this.changeDashboardTabSelectedPondIds({
          pondIds: [],
          tab: selectedLabel
        });
      }
      await this.changeSelectedTab(selectedLabel);

      this.loading = false;
    },
    sortDo(a, b) {
      return (
        (this.getPondIdToLatestNDOTempValues[a._id].map(x => x.do)[0] || -999) -
        (this.getPondIdToLatestNDOTempValues[b._id].map(x => x.do)[0] || -999)
      );
    },
    sortTemperature(a, b) {
      return (
        (this.getPondIdToLatestNDOTempValues[a._id].map(x => x.temp)[0] ||
          -999) -
        (this.getPondIdToLatestNDOTempValues[b._id].map(x => x.temp)[0] || -999)
      );
    },
    async clearSelectionClick() {
      await this.changeDashboardTabSelectedPondIds({
        pondIds: [],
        tab: this.selectedTab
      });
      await this.changeSelectedPonds({ selected_ponds: [] });
    },
    handleChangeInColumnSelection(selectedColumns) {
      const columnObj = selectedColumns.reduce((acc, curr) => {
        acc[curr] = this.tableColumns[curr];
        return acc;
      }, {});
      this.selectedColumnsKeys = selectedColumns;
      this.selectedHeaders = Object.assign({}, columnObj);
    },
    handleChangeInSelectedPonds(selectedPondsIds) {
      this.selectedPondsIds = selectedPondsIds;
    },
    async handleChangeInDateRange(event) {
      try {
        await this.initComponent();
      } catch (err) {
        this.errorMessages(err, true);
      }
    },
    async prevDayClick() {},
    async nextDayClick() {},
    searchClick(event) {
      this.isDeactive = !this.isDeactive;
    },
    initDate() {
      this.date = this.$moment()
        .utcOffset(this.getUserTimeZone.offset)
        .format("YYYY-MM-DD");
    },
    async initComponent() {
      this.loading = true;
      try {
        const selectedTab = (
          this.$route.query.pondStatus || this.getSelectedTab
        ).toUpperCase();
        await this.changeLocation(this.getCurrUserLocation);
        await this.handleTabClick(selectedTab, "INIT");
        this.handleChangeInColumnSelection(this.selectedColumnsKeys);
      } catch (err) {
        this.errorMessages(err, true);
      } finally {
        this.loading = false;
      }
    },
    pondNameFilterHandler(value, row, column) {
      const property = column.property;
      return row[property] === value;
    },
    async handleExpandClick(expandStatus) {
      this.changeShowGraphsPanelStatus(expandStatus);
      // await this.fetchAllPondsPmDetails();
    }
  }
};
</script>

<style lang="scss">
@import "@/styles/mixins.scss";
.pond-info-tab {
  .icon {
    opacity: 0.75;
  }
  .column__selectors {
    filter: invert(94%) sepia(6%) saturate(288%) hue-rotate(182deg)
      brightness(84%) contrast(90%);
  }
  .column__selectors:hover {
    cursor: pointer;
    filter: invert(10%) sepia(11%) saturate(493%) hue-rotate(190deg)
      brightness(94%) contrast(96%);
  }
  .collapsebutton__selectors {
    color: #c0c4cc;
  }
  .collapsebutton__selectors:hover {
    color: black;
  }

  .divider {
    width: 100%;
    height: 1px;
    opacity: 0.2;
    margin: 0 auto;
    display: inline-block;
    background-color: #6c7b8a;
    margin-bottom: 15px;
    margin-top: 10px;
  }
  .el-card__body {
    padding: 10px;
  }
  .pre-table-header {
    &__right {
      position: relative;
      float: right;
      display: flex;
      justify-content: flex-end;
      .day-picker-top {
        display: flex;
        @include responsiveProperty(width, 100px, 150px, 150px);
      }
      img {
        width: 16px;
      }
      .el-select {
        margin-left: 0.5rem;
        .el-input__inner {
          border: 0px solid #dcdfe6;
        }
      }
      .clear-selection-icon {
        &:hover {
          cursor: pointer;
          filter: invert(0%) sepia(2%) saturate(0%) hue-rotate(199deg)
            brightness(100%) contrast(0%);
        }
      }

      .search-bar {
        position: relative;
        display: flex;
        align-items: center;

        // padding-right: 4px;
        input {
          background: white;
          border: 0px solid #dcdfe6;
          border-radius: 8px;
          color: black !important;
        }
        img {
          cursor: pointer;
          width: 16px;
          position: absolute;
          bottom: 0;
          right: 0;
          margin: 6px;
        }
        .el-input--small .el-input__inner {
          height: 28px;
          line-height: 28px;
        }
        .search_icon {
          @include responsiveProperty(font-size, 1.15em, 1em, 0.75em);
        }
      }
      .search-bar-size {
        width: 180px;
        border-bottom: 0.7px solid gray;
      }
      .hideDayPicker {
        display: none !important;
      }
      .save-pref-container {
        display: flex;
        padding-left: 12px;
        padding-top: 0.5rem;
        padding-bottom: 0.5rem;
        border-top: 1px solid lightgray;
        p {
          padding-left: 10px;
          color: #44a1ff;
          cursor: pointer;
        }
        img {
          cursor: pointer;
          width: 16px;
        }
      }
    }
    &__left {
      .el-radio-group {
        .el-radio-button__inner {
          @include small-text;
          padding: 7px 15px;
        }
      }
      .el-radio-button__orig-radio:checked + .el-radio-button__inner {
        color: #ffffff;
        background: $button-color;
        border-color: $button-color;
        box-shadow: -1px 0 0 0 $button-color;
      }
      .el-radio-button__orig-radio + .el-radio-button__inner {
        color: #0a2463fe;
      }
      .el-radio-button__orig-radio:disabled + .el-radio-button__inner {
        opacity: 0.6;
      }
    }
  }
}
</style>
